import { createAction } from '@reduxjs/toolkit';
import { FETCH_CHECKOUT } from '../actions-constants';
import type { CheckoutError } from './checkout-error';

export const clearCheckoutError = createAction('CLEAR_CHECKOUT_ERROR');
export const fetchCheckoutError = createAction<CheckoutError>(FETCH_CHECKOUT.ERROR);
